import styled from 'styled-components';
// import { svg } from '_utils/styles/';

/* 
inexplicably
adding ${svg(24, 24)} into style defn, causes server error when deployed  
Object(...) is not a function TypeError: Object(...) is not a function 
*/

export const NoBreakWrapper = styled.span`
  white-space: nowrap;
`;

export const IconWrapper = styled.span`
  position: relative;
  display: inline-block;
  margin-right: 8px;
  transform: translateY(-10%);
  height: 20px;
  white-space: nowrap;

  svg,
  img {
    vertical-align: middle;
    width: 20px;
    height: auto;
  }

  path {
    fill: ${({ theme }) => theme.card.attributeIcon};
  }
`;
